import { PDF_TOOLS } from '@/data/pdfTools';
import { usePdfStore } from '@/stores/pdfStore';

interface PdfMobileContextStripProps {
  busy?: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

/** Slim strip under tools: undo/redo, tool hint, zoom. */
export default function PdfMobileContextStrip({
  busy,
  onUndo,
  onRedo,
}: PdfMobileContextStripProps) {
  const tool = usePdfStore((s) => s.tool);
  const zoomMode = usePdfStore((s) => s.zoomMode);
  const setZoomMode = usePdfStore((s) => s.setZoomMode);
  const canUndo = usePdfStore((s) => s.canUndo(s.activePageIndex));
  const canRedo = usePdfStore((s) => s.canRedo(s.activePageIndex));

  const def = PDF_TOOLS.find((t) => t.id === tool);
  const hint = def?.hint ?? '';

  return (
    <div className="pdfe-mobile-context" aria-label="Tool context">
      <div className="pdfe-mobile-context-actions">
        <button
          type="button"
          className="pdfe-icon-btn"
          disabled={!canUndo || busy}
          onClick={onUndo}
          title="Undo"
          aria-label="Undo"
        >
          ↶
        </button>
        <button
          type="button"
          className="pdfe-icon-btn"
          disabled={!canRedo || busy}
          onClick={onRedo}
          title="Redo"
          aria-label="Redo"
        >
          ↷
        </button>
      </div>
      <p className="pdfe-mobile-context-hint" title={hint}>
        <strong>{def?.label ?? 'Tool'}</strong>
        <span>{hint}</span>
      </p>
      <label className="pdfe-mobile-zoom">
        <span className="sr-only">Zoom</span>
        <select
          value={zoomMode === 'auto' ? 'auto' : String(zoomMode)}
          onChange={(e) => {
            const v = e.target.value;
            setZoomMode(v === 'auto' ? 'auto' : Number(v));
          }}
        >
          <option value="auto">Fit</option>
          <option value="0.5">50%</option>
          <option value="0.75">75%</option>
          <option value="1">100%</option>
          <option value="1.25">125%</option>
          <option value="1.5">150%</option>
          <option value="2">200%</option>
        </select>
      </label>
    </div>
  );
}
